import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import SubgroupMenu from "components/UnifiedProject/SubgroupMenu/SubgroupMenu";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

class SubgroupMenuContainer extends React.Component {
  state = {
    show: false
  };

  handleClick(e, override) {
    const { onClick } = this.props;
    if (onClick) {
      return onClick();
    }
    return this.setState({
      show: override !== undefined ? override : !this.state.show
    });
  }

  render() {
    return <SubgroupMenu {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;
  return {
    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  const runId = projectReducer.getRunId(state, id);
  const innerId = projectReducer.getInnerId(state, id);

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== id) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }
  return {
    runId,
    innerId: innerId,
    setupLabels: setupReducer.getSetupLabels(state, runId),
    dataset: setupReducer.getDatasetFromSetup(state, innerId),

    project: projectReducer.getProject(state, id),
    optimizer: projectReducer.getOptimizer(state, id),
    modelGroups: modelGroups
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SubgroupMenuContainer);
